module.exports = __webpack_public_path__ + "media/icon/icon-local_laundry_service-gray-2756f2a5.svg";